import { defineComponent as _defineComponent } from 'vue'
import { BKModal } from '@/shared/ui/modals'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsorBanner',
  setup(__props) {

const showModal = ref(false)

return { __sfc: true,showModal, BKModal }
}

})